import { FocusMonitor } from "@angular/cdk/a11y";
import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ElementRef, Input, forwardRef } from "@angular/core";
import { NgControl } from "@angular/forms";
import { ErrorStateMatcher, MatFormFieldControl } from "@angular/material";
import { Subject } from "rxjs";
import { AutocompleteComponent } from "./autocomplete.component";

export const MAT_FORM_FIELD_CONTROL = { provide: MatFormFieldControl, useExisting: forwardRef(() => AutocompleteComponent) };
export class AutoCompleteFormField implements MatFormFieldControl<any> {
  id: string;

  get empty(): boolean {
    return !this.input.nativeElement.value;
  }
  errorState = false;
  @Input() errorStateMatcher: ErrorStateMatcher;
  
  private _defaultErrorStateMatcher: ErrorStateMatcher = new ErrorStateMatcher();
  
  controlType?: string;
  autofilled?: boolean;

  input: ElementRef<HTMLInputElement>;
  
  ngControl: NgControl;

  stateChanges = new Subject<void>();
  focused = false;

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  @Input()
  get placeholder(): string {
    return this._placeholder;
  }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean {
    return this._required;
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): any {
    return this._value;
  }
  set value(v: any) {
    this._value = v;
    this.stateChanges.next();
  }
  private _value: any;

  constructor(
    protected _focusMonitor: FocusMonitor,
    protected _elementRef: ElementRef
  ) {}

  setDescribedByIds(ids: string[]): void {
    const controlElement =
      this._elementRef.nativeElement.querySelector(".tvk-autocomplete")!;
    controlElement.setAttribute("aria-describedby", ids.join(" "));
  }

  onContainerClick() {
    return this._focusMonitor.focusVia(this._elementRef, "program");
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this._focusMonitor.stopMonitoring(this._elementRef);
  }

  protected _defineElementMonitor(onTouched: Function) {
    this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
      if (this.focused && !origin) {
        onTouched();
      }
      
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }
}